import { useTranslation } from "react-i18next";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";

const HelpYourChildSection = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const items = [
    {
      img: "/programPage/program1.jpg",
      text: t("ProgramPage.HelpYourChildSection.programItems.item1"),
    },
    {
      img: "/programPage/program2.jpg",
      text: t("ProgramPage.HelpYourChildSection.programItems.item2"),
    },
    {
      img: "/programPage/program3.jpg",
      text: t("ProgramPage.HelpYourChildSection.programItems.item3"),
    },
    {
      img: "/programPage/program4.jpg",
      text: t("ProgramPage.HelpYourChildSection.programItems.item4"),
    },
    {
      img: "/programPage/program5.jpg",
      text: t("ProgramPage.HelpYourChildSection.programItems.item5"),
    },
    {
      img: "/programPage/program6.jpg",
      text: t("ProgramPage.HelpYourChildSection.programItems.item6"),
    },
  ];

  return (
    <Box sx={{ pb: 4, px: isMobile ? "2%" : "25%", textAlign: "center" }}>
      <Typography
        variant="h2"
        gutterBottom
        textAlign={"center"}
        fontWeight={800}
        color={theme.palette.text.secondary}
        mt={4}
      >
        {t("ProgramPage.HelpYourChildSection.title")}
      </Typography>
      <Grid container spacing={4} justifyContent="center" mt={isMobile ? 4 : 8}>
        {items.map(({ img, text }, index) => (
          <Grid item xs={6} sm={6} md={4} key={index}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box
                component="img"
                src={img}
                alt={text}
                sx={{
                  width: 116,
                  height: 116,
                  mb: 2,
                }}
              />
              <Typography variant="h5" fontWeight={700}>
                {text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HelpYourChildSection;
